<template>
  <div class="setup-wizard">
    <div class="setup-wizard__header-step">
      <span class="setup-wizard__header-step-title">Create Super User</span>
    </div>
    <div class="setup-wizard__body">
      <div class="setup-wizard__content">
        <v-form ref="passwordForm" lazy-validation>
          <v-text-field
            light
            autocomplete="kName"
            name="kName"
            class="setup-wizard__form-item"
            v-model="model.user.name"
            :label="$t('USER-LABEL-NAME')"
            :rules="[rules.required, rules.name]"
          >
          </v-text-field>

          <v-text-field
            light
            class="setup-wizard__form-item"
            autocomplete="kEmail"
            name="kEmail"
            v-model="model.user.email"
            :label="$t('USER-LABEL-EMAIL')"
            :rules="[rules.required, rules.email]"
          >
          </v-text-field>

          <v-select
            light
            class="setup-wizard__form-item"
            v-model="model.user.language_id"
            :items="languages"
            item-text="name"
            item-value="id"
            :label="$t('USER-LABEL-LANGUAGE')"
            :rules="[rules.required]"
          >
          </v-select>

          <password-field class="setup-wizard__form-item" light v-model="model.user.password" label="USER-LABEL-PASSWORD-NEW"></password-field>
          <v-text-field
            light
            class="setup-wizard__form-item"
            v-model="model.user.rePassword"
            type="password"
            :label="$t('USER-LABEL-PASSWORD_NEW-REPEAT')"
            required
            :rules="[passwordConfirmationRule]"
          ></v-text-field>
        </v-form>
      </div>
      <div class="setup-wizard__actions">
        <div class="setup-wizard__actions-wrapper">
          <v-btn rounded elevation="0" light small class="setup-wizard__btn--cancel" @click="cancel">Cancel</v-btn>
          <v-btn rounded elevation="0" light :disabled="!canGoNext" small class="setup-wizard__btn" @click="next">Next</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import passwordField from "@/components/PasswordField";

export default {
  name: "SetupWizardStep2",
  components: {
    passwordField,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: null,
      canGoNext: false,
    };
  },
  computed: {
    languages() {
      let languages = [
        {
          id: 1,
          name: this.$t("GLOBAL-LANG-DE"),
          shortcode: "de",
        },
        {
          id: 2,
          name: this.$t("GLOBAL-LANG-EN"),
          shortcode: "en",
        },
        {
          id: 3,
          name: this.$t("GLOBAL-LANG-ES"),
          shortcode: "es",
        },
      ];
      return languages;
    },
    passwordConfirmationRule() {
      return this.model.user.password === this.model.user.rePassword || this.$t("GLOBAL-FORM-PASSWORDS_MUST_MATCH");
    },
  },
  updated() {
    this.canGoNext = this.$refs.passwordForm.validate();
  },
  created() {
    this.model = cloneDeep(this.data);
  },
  methods: {
    next() {
      this.$emit("next", cloneDeep(this.model));
    },
    cancel(){
      this.$emit('cancel');
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
